module.exports = __webpack_public_path__ + "img/close_l.7fc0269.svg";